<template>
  <div class="loading-spinner" :style="spinnerStyle"></div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    size: {
      type: Number,
      default: 14
    },
    color: {
      type: String,
      default: '#fff'
    },
    borderWidth: {
      type: Number,
      default: 4
    }
  },
  computed: {
    spinnerStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderWidth: `${this.borderWidth}px`,
        borderColor: `rgba(255, 255, 255, 0.3)`,
        borderTopColor: this.color
      }
    }
  }
}
</script>

<style scoped>
.loading-spinner {
  display: inline-block;
  border-radius: 50%;
  animation: spin 1s ease-in-out infinite;
  vertical-align: middle;
  margin-right: 5px;
  position: relative;
  top: -1px;
  border-style: solid;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>